import { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "../../styles/penalty-recovery.css";
import useCtaWiring from "../../hooks/useCtaWiring";
import PenaltyRecoveryFreeCheck from "./PenaltyRecoveryFreeCheck";
import { ClosedBanner, ClosedContactSection } from "./PenaltyRecoveryClosedNotice";
import landingTop from "./_generated/landingTop";
import landingBottom from "./_generated/landingBottom";
import navInner from "./_generated/navInner";

const NAV_STYLE = {
  position: "sticky",
  top: 0,
  zIndex: 60,
  background: "rgba(255,255,255,0.92)",
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  borderBottom: "1px solid #ECE9E0",
};

/**
 * COVID Penalty Recovery — public landing page (kgob.com/penalty-recovery).
 * Static design markup is preserved verbatim from the uploaded package and
 * rendered via dangerouslySetInnerHTML; the interactive free 2-minute check is
 * a faithful React island mounted between the two static fragments. All CTAs
 * that lead into the paid funnel route to app.kgob.com (see penaltyRecoveryApi).
 */
export default function PenaltyRecoveryLanding() {
  const rootRef = useRef(null);
  useCtaWiring(rootRef, "landing");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pr-page" ref={rootRef} data-testid="penalty-recovery-landing">
      <Helmet>
        <title>COVID Penalty Recovery — Recover IRS Penalties | KGOB CPAs &amp; Advisors</title>
        <meta name="description" content="KGOB is no longer accepting new COVID penalty recovery applications — the remaining time before the filing deadline is too short to responsibly prepare new claims. Existing clients' applications continue to be processed. Still need a CPA? Call 844-599-3355." />
        <link rel="canonical" href="https://kgob.com/penalty-recovery" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="COVID Penalty Recovery — Recover IRS Penalties | KGOB" />
        <meta property="og:description" content="A federal court found COVID-era tax deadlines were extended. If you paid late-filing or late-payment penalties on a 2019–2022 return, you may be able to claim that money back." />
        <meta property="og:url" content="https://kgob.com/penalty-recovery" />
      </Helmet>
      <nav style={NAV_STYLE} data-testid="penalty-recovery-nav" dangerouslySetInnerHTML={{ __html: navInner }} />
      <ClosedBanner />
      <ClosedContactSection />
      <div dangerouslySetInnerHTML={{ __html: landingTop }} />
      <PenaltyRecoveryFreeCheck />
      <div dangerouslySetInnerHTML={{ __html: landingBottom }} />
    </div>
  );
}
